/**
 * URL canonique des résultats produits côté client.
 */
export function buildCategoriesSearchUrl(query) {
  const trimmed = String(query || '').trim();
  if (!trimmed) return '/categories';
  return `/categories?search=${encodeURIComponent(trimmed)}`;
}
